<template>

  <Paginaty
    :total="invoices.total"
    :pages="invoices.pages"
    :page="invoices.page"
    :creating="creating"
    :loading="loading"
    @changePage="loadData">
    
    <template slot="content">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Fatura</th>
            <th scope="col">Data do vencimento</th>
            <th scope="col">Valor</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody v-if="invoices.docs"> 
          <BillingInvoicesItem
            v-for="(item, index) in invoices.docs"
            :key="index"
            :value="item" />
        </tbody>
      </table>
    </template>

    <template slot="noresults">
      {{ $t('There are no items') }}
    </template>
  </Paginaty>

</template>

<script>
import Paginaty from '@/components/Paginaty/Paginaty'
import BillingInvoicesItem from './BillingInvoicesItem'

export default {
  name: 'BillingInvoices',
  components: {
    Paginaty,
    BillingInvoicesItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      invoices: {
        pages: null,
        total: null,
        limit: null,
        page: null,
        docs: null
      }
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData (page) {
      this.loading = true

      this.$store.dispatch('getBillingInvoices', { page: page }).then(res => {
        this.invoices = res
        this.creating = this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingInvoices.vue